import { Navigate } from "react-router-dom";

import { DashboardLayout } from "../components/shared";
import ClientBlockGuard from "./ClientBlockGuard";
import ProjectInviteRoute from "./ProjectInviteRoute";
import TeamInviteAcceptRoute from "./TeamInviteAcceptRoute";
import {
  Projects,
  ProjectTasks,
  ProjectFiles,
  ProjectSettings,
  ForgotPassword,
  Login,
  ResetPassword,
  Signup,
  Splash,
  Suggestions,
  Success,
  Profile,
  AdminLayout,
  Users,
  SupportInbox,
  Experience,
  ProfileDetails,
  Certifications,
  Education,
  Licenses,
  Recommendations,
  Skills,
  EditProfilePage,
  Partner,
  MatchedPartners,
  SuggestedPartners,
  PrioritizedPartners,
  Clients,
  UserDetails,
  NearestPartners,
  PartnersDetails,
  Chats,
  AccountSettings,
  TermsAndCondition,
  PrivacyPolicy,
  RequestedPartners,
  RequestedPartnersV2,
  Dashboard,
  SupportHub,
  FaqPage,
  Reviews,
  DraftFlow,
  TeamList,
  TeamWorkspace,
  MyTasks,
  CalendarPage,
  CalendarV2Page,
  NewDashboard,
  PublicFileShare,
} from "./pageComponents";

const supportInboxRoute = {
  path: "/support-inbox",
  moduleName: "Admin",
  element: (
    <AdminLayout>
      <SupportInbox />
    </AdminLayout>
  ),
};

// ADMIN PRIVATE ROUTES
export const adminPrivateRoutes = [
  {
    path: "/users",
    moduleName: "Admin",
    element: (
      <AdminLayout>
        <Users />
      </AdminLayout>
    ),
  },
  {
    path: "/dashboard",
    moduleName: "Admin",
    element: (
      <AdminLayout>
        <Dashboard />
      </AdminLayout>
    ),
  },
  {
    path: "/users/user-detail/:id",
    moduleName: "Admin",
    element: (
      <AdminLayout>
        <UserDetails />
      </AdminLayout>
    ),
  },
  supportInboxRoute,
];

export const supportStaffPrivateRoutes = [supportInboxRoute];

// USER PRIVATE ROUTES
export const userPrivateRoutes = [
  {
    path: "/suggestions",
    moduleName: "Dashboard",
    element: <Suggestions />,
  },
  {
    path: "/success",
    moduleName: "Dashboard",
    element: <Success />,
  },
  {
    path: "/dashboard",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <NewDashboard />
      </DashboardLayout>
    ),
  },
  {
    path: "/support",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <SupportHub />
      </DashboardLayout>
    ),
  },
  {
    path: "/faq",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <FaqPage />
      </DashboardLayout>
    ),
  },
  // ── Projects Routes ──────────────────────────────────────────────────────
  {
    path: "/projects",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <Projects />
      </DashboardLayout>
    ),
  },
  // ── Cross-Account Tasks Route ────────────────────────────────────────────
  {
    path: "/tasks",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <MyTasks />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  // ── Calendar Route ───────────────────────────────────────────────────────
  {
    path: "/calendar",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <CalendarPage />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  // ── Calendar V2 Route ────────────────────────────────────────────────────
  {
    path: "/calendar-v2",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <CalendarV2Page />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  // ── Project Sub-Routes ──────────────────────────────────────────────────
  {
    path: "/projects/:status",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <Projects />
      </DashboardLayout>
    ),
  },
  {
    path: "/projects/:id/tasks",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <ProjectTasks />
      </DashboardLayout>
    ),
  },
  {
    path: "/projects/:id/tasks/:taskId",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <ProjectTasks />
      </DashboardLayout>
    ),
  },
  {
    path: "/projects/:projectId/draft-flow",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <DraftFlow />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/projects/:projectId/draft-flow/:sessionId",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <DraftFlow />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/projects/:id/settings",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <ProjectSettings />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/projects/:id/files",
    moduleName: "Dashboard",
    element: (
      <DashboardLayout>
        <ProjectFiles />
      </DashboardLayout>
    ),
  },
  {
    path: "/teams",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamList />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/teams/:id",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamWorkspace />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/teams/:id/members",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamWorkspace />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/teams/:id/invites",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamWorkspace />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/teams/:id/storage",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamWorkspace />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/teams/:id/settings",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <TeamWorkspace />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/network",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <Partner />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
    child: [
      {
        path: "",
        element: <Navigate to="suggestions" replace />,
      },
      {
        path: "suggestions",
        moduleName: "Suggestions",
        element: <SuggestedPartners />,
      },
      {
        path: "my-network",
        moduleName: "Matched",
        element: <MatchedPartners />,
      },
      {
        path: "clients",
        moduleName: "Clients",
        element: <Clients />,
      },
      {
        path: "favorited",
        moduleName: "Prioritized",
        element: <PrioritizedPartners />,
      },
      {
        path: "nearest",
        moduleName: "Nearest",
        element: <NearestPartners />,
      },
      {
        path: "requests",
        moduleName: "Requests",
        element: <RequestedPartners />,
      },
      {
        path: "requests-v2",
        moduleName: "Requests V2",
        element: <RequestedPartnersV2 />,
      },
    ],
  },
  {
    path: "/network/partner-detail/:id",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <PartnersDetails />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/partners/partner-detail/:id",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <PartnersDetails />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/partners",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <Navigate to="/network" replace />
      </ClientBlockGuard>
    ),
  },
  {
    path: "/partners/*",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <Navigate to="/network" replace />
      </ClientBlockGuard>
    ),
  },
  {
    path: "/chat",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <Chats />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/draft-flow",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <DraftFlow />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/draft-flow/:sessionId",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <DraftFlow />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/account-settings",
    moduleName: "Dashboard",
    element: (
      <ClientBlockGuard>
        <DashboardLayout>
          <AccountSettings />
        </DashboardLayout>
      </ClientBlockGuard>
    ),
  },
  {
    path: "/profile",
    moduleName: "Profile",
    element: (
      <DashboardLayout>
        <Profile />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/experience",
    moduleName: "Experience",
    element: (
      <DashboardLayout>
        <Experience />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/certifications",
    moduleName: "Certifications",
    element: (
      <DashboardLayout>
        <Certifications />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/profile-details",
    moduleName: "Profile Details",
    element: (
      <DashboardLayout>
        <ProfileDetails />
      </DashboardLayout>
    ),
  },
 
  {
    path: "/profile/education",
    moduleName: "Education",
    element: (
      <DashboardLayout>
        <Education />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/licenses",
    moduleName: "Licenses",
    element: (
      <DashboardLayout>
        <Licenses />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/recommendations",
    moduleName: "Recommendations",
    element: (
      <DashboardLayout>
        <Recommendations />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/reviews",
    moduleName: "Reviews",
    element: (
      <DashboardLayout>
        <Reviews />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/skills",
    moduleName: "Skills",
    element: (
      <DashboardLayout>
        <Skills />
      </DashboardLayout>
    ),
  },
  {
    path: "/profile/edit",
    moduleName: "Edit Profile",
    element: (
      <DashboardLayout>
        <EditProfilePage />
      </DashboardLayout>
    ),
  },
];

// PUBLIC ROUTES
export const publicRoutes = [
  {
    path: "/projects/invite/:token",
    moduleName: "Dashboard",
    element: <ProjectInviteRoute />,
  },
  {
    path: "/teams/invite/:token",
    moduleName: "Teams",
    element: <TeamInviteAcceptRoute />,
  },
  {
    path: "/",
    moduleName: "Authentication",
    element: <Splash />,
  },
  {
    path: "/login",
    moduleName: "Authentication",
    element: <Login />,
  },
  {
    path: "/signup",
    moduleName: "Authentication",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    moduleName: "Authentication",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    moduleName: "Authentication",
    element: <ResetPassword />,
  },
  {
    path: "/terms-and-conditions",
    moduleName: "Authentication",
    element: <TermsAndCondition />,
  },
  {
    path: "/files/shared/:token",
    moduleName: "Files",
    element: <PublicFileShare />,
  },
  {
    path: "/Privacy-policy",
    moduleName: "Authentication",
    element: <PrivacyPolicy />,
  },
];

export const getPrivateRoutesForPermissions = (permissions = []) => {
  if (permissions.some((permission) => ["superadmin", "admin"].includes(permission))) {
    return adminPrivateRoutes;
  }
  if (permissions.includes("staff")) {
    return supportStaffPrivateRoutes;
  }
  return userPrivateRoutes;
};
